var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6313 0.868654C16.2561 1.49349 16.2561 2.50656 15.6313 3.1314L7.63127 11.1314C7.00643 11.7562 5.99337 11.7562 5.36853 11.1314L1.36853 7.1314C0.743693 6.50656 0.743693 5.49349 1.36853 4.86865C1.99337 4.24381 3.00643 4.24381 3.63127 4.86865L6.4999 7.73728L13.3685 0.868654C13.9934 0.243815 15.0064 0.243815 15.6313 0.868654Z",
    fill: "#0BB70A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/Mark.9704e402e04465c922ad21990e831966.svg";
export { ForwardRef as ReactComponent };